module.exports = __webpack_public_path__ + "dist/assets/img/pictures.392ab760.svg";